import { 
  Component, 
  OnInit,
  OnDestroy,
  OnChanges,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  Inject,
  ViewChild,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles
} from './models/control';
import { Styles, ControlContainerStyles, CardStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { DatexFormControl } from './models/datex-form-control';
import { BaseComponent } from './components/base.component';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootPrintPortalManager_ShellService } from './FootPrintPortalManager.shell.service';
import { FootPrintPortalManager_OperationService } from './FootPrintPortalManager.operation.service';
import { FootPrintPortalManager_DatasourceService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_FlowService } from './FootPrintPortalManager.flow.index';
import { FootPrintPortalManager_ReportService } from './FootPrintPortalManager.report.index';
import { FootPrintPortalManager_LocalizationService } from './FootPrintPortalManager.localization.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootPrintPortalManager.frontend.types'
import { $frontendTypes as $types} from './FootPrintPortalManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';



@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootPrintPortalManager-reports_card',
  templateUrl: './FootPrintPortalManager.reports_card.component.html'
})
export class FootPrintPortalManager_reports_cardComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {
  styles = new CardStyles(['creation','border-left']);

  inParams: { report_name: string, report_description?: string, projectId?: number } = { report_name: null, report_description: null, projectId: null };
  //#region Inputs
  @Input('report_name') set $inParams_report_name(v: string) {
    this.inParams.report_name = v;
  }
  get $inParams_report_name(): string {
    return this.inParams.report_name;
  }
  @Input('report_description') set $inParams_report_description(v: string) {
    this.inParams.report_description = v;
  }
  get $inParams_report_description(): string {
    return this.inParams.report_description;
  }
  @Input('projectId') set $inParams_projectId(v: number) {
    this.inParams.projectId = v;
  }
  get $inParams_projectId(): number {
    return this.inParams.projectId;
  }
  //#endregion Inputs

  //#region Outputs
  outParams: { refreshedDate?: string } = { refreshedDate: null };
  //#endregion
  //#region Variables
  vars: { report_name?: string } = { };
  //#endregion
  //#region Events
  @Output()
  openEditorClick = new EventEmitter<number>();
  @Output()
  outParamsChange = new EventEmitter<{ refreshedDate?: string }>();
  
  events = {
    openEditorClick: this.openEditorClick,
    outParamsChange: { emit: () => { this.outParamsChange.emit(this.outParams); } }
  }
  //#endregion

  @Output()
  $refreshEvent = new EventEmitter();

  actionbar = {
      report_subscription: new ToolModel(new ButtonModel('report_subscription', new ButtonStyles(null, null), false, false, 'Subscribe', 'icon-ic_fluent_mail_alert_20_regular', null)
    , false)
  };

  formGroupContent: FormGroup = new FormGroup({
    report_description: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });


  content = {
    fields: {
        report_description: new FieldModel(new TextBoxModel(this.formGroupContent.controls['report_description'] as DatexFormControl, null, true, '', null)
, new ControlContainerStyles(null, null), 'Description', false, false),
    },
    fieldsets: {
  newGroup1: new FieldsetModel('Label of newGroup1', true, false, true, false),
}
  }


  
  //#region content fields inParams
  //#endregion content fields inParams



  get headerTitle() {
    const $card = this;
    const $utils = this.utils;
    const expr = $card.vars.report_name;
    return expr;
  }






  constructor(private utils: UtilsService,
private settings: SettingsValuesService,
private shell: FootPrintPortalManager_ShellService,
private datasources: FootPrintPortalManager_DatasourceService,
private flows: FootPrintPortalManager_FlowService,
private reports: FootPrintPortalManager_ReportService,
private localization: FootPrintPortalManager_LocalizationService,
private operations: FootPrintPortalManager_OperationService,
private logger: CleanupLoggerService,
) {
    super(); 
    this.$subscribeFormControlValueChanges();

  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }
  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.report_name)) {
        this.$missingRequiredInParams.push('report_name');
      }
  }

  initialized = false;

  async $init() {

    const $card = this;
    const $utils = this.utils;

    


    await this.on_init();

    this.initialized = true;

  }

  private $subscribeFormControlValueChanges() {

  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }
 
  //#region private flows
  on_email_subscription(event = null) {
    return this.on_email_subscriptionInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_email_subscriptionInternal(
    $card: FootPrintPortalManager_reports_cardComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
    this.logger.log('FootPrintPortalManager', 'reports_card.on_email_subscription');
  throw new Error ('Subscribing to the selected report currently under development.')
  }
  on_open_report_clicked(event = null) {
    return this.on_open_report_clickedInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_open_report_clickedInternal(
    $card: FootPrintPortalManager_reports_cardComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
    this.logger.log('FootPrintPortalManager', 'reports_card.on_open_report_clicked');
  
  
  await $shell.Inventory.openinventory_by_project_reportDialog({projectId: $card.inParams.projectId});
  
  //throw new Error ('Running the selected report currently under development.')
  }
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $card: FootPrintPortalManager_reports_cardComponent,
  
    $shell: FootPrintPortalManager_ShellService,
    $datasources: FootPrintPortalManager_DatasourceService,
    $flows: FootPrintPortalManager_FlowService,
    $reports: FootPrintPortalManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootPrintPortalManager_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootPrintPortalManager_LocalizationService,
    $event: any
  ) {
    this.logger.log('FootPrintPortalManager', 'reports_card.on_init');
  let report_name = $card.inParams.report_name;
  let report_description = $card.inParams.report_description;
  
  $card.vars.report_name = report_name;
  $card.content.fields.report_description.control.value = report_description;
  }
  //#endregion private flows

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);

    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
  }


}
